import { computed } from 'mobx';

export default class ImageSourceDeviceModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.imagesource_id = +item.imagesource_id;
    this.device_code = item.device_code;
    this.station_id = item.station_id;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      imagesource_id: +this.imagesource_id,
      device_code: this.device_code,
      station_id: this.station_id,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.imagesource_id = +json.imagesource_id;
    this.device_code = json.device_code;
    this.station_id = json.station_id;
  }
}



// WEBPACK FOOTER //
// ./src/models/IDaq/ImageSourceDeviceModel.js